import styled from "styled-components"
import { motion } from "framer-motion"

export const Nav = styled(motion.div)`
  position: fixed;
  top: 0;
  margin-right:sasa
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  background-color: ${props => props.theme.red};
  color: #000;
  z-index: 2;
  overflow: hidden;
`

export const NavHeader = styled.div`
  top: 72px;

  position: relative;
  h2 {
    color: ${props => props.theme.background};
  }
`

export const CloseNav = styled.div`
  button {
    transform-origin: center;
    border: none;
    padding: 2rem;
    background: none;
    outline: none;
    span {
      width: 3.6rem;
      height: 1rem;
      display: block;
      background-color: ${props => props.theme.background};
      margin: 8px;
    }
  }
`

export const NavList = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;

  ul {
    padding: 0;
    li {
      list-style: none;
      font-size: 5rem;
      text-transform: uppercase;
      font-weight: 900;
      height: 9.6rem;
      line-height: 9.6rem;
      overflow: hidden;

      .link {
        color: ${props => props.theme.background};
        position: relative;
        display: flex;
        align-items: center;
        font-weight: 1200;
        .arrow {
          height: 7.6rem;
          margin-right: 8px;

          svg {
            width: 10rem;
            path {
              fill: ${props => props.theme.background};
            }
          }
        }
      }
    }
  }
`
export const NavVideos = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 28%;
  z-index: -1;
  height: 100%;
  width: 100%;
  background-color: #000;

  .reveal {
    width: 100%;
    background: ${props => props.theme.red};
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
  }

  .video {
    height: 100%;
    position: absolute;
    margin: 0;
    z-index: -1;

    video {
      height: 100%;
    }
  }
`

export const NavFooter = styled.div``
